/**
 * Creates a validator function that checks that a `number` value is not greater than a maximum value (inclusive).
 * @param max The maximum value that the `number` can be.
 */
export const validateMax = (max) => {
    return (value, logger, logLabel) => {
        const valid = max === undefined || value <= max;
        if (!valid)
            logger(`${logLabel} cannot be more than ${max}.`);
        return valid;
    };
};
//# sourceMappingURL=max.js.map